'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decurve = require('./decurve');

var _decurve2 = _interopRequireDefault(_decurve);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var boundingBox = function boundingBox(s) {
  var bottom = void 0;
  var left = void 0;
  var right = void 0;
  var top = void 0;

  var shapes = (0, _helpers.getShapeArray)(s);

  shapes.map(function (shape) {
    return (0, _decurve2.default)(shape).map(function (_ref) {
      var x = _ref.x;
      var y = _ref.y;

      if (typeof bottom !== 'number' || y > bottom) {
        bottom = y;
      }

      if (typeof left !== 'number' || x < left) {
        left = x;
      }

      if (typeof right !== 'number' || x > right) {
        right = x;
      }

      if (typeof top !== 'number' || y < top) {
        top = y;
      }
    });
  });

  return {
    bottom: bottom,
    center: {
      x: left + (right - left) / 2,
      y: top + (bottom - top) / 2
    },
    left: left,
    right: right,
    top: top
  };
};

exports.default = boundingBox;